import React from "react";

type ExpertFormSectionCardProps = {
    title: string;
    extra?: React.ReactNode;
    children: React.ReactNode;
};

export const ExpertFormSectionCard = ({
    title,
    extra,
    children,
}: ExpertFormSectionCardProps) => {
    return (
        <div className="mb-4 border rounded p-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="mb-0">{title}</h6>
                {extra}
            </div>
            <div className="row">{children}</div>
        </div>
    );
};

type ExpertFormTextFieldProps = {
    label: string;
    value?: string;
    name: string;
    id?: string;
    colClassName?: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const ExpertFormTextField = ({
    label,
    value,
    name,
    id,
    colClassName = "form-group col-md-2 mb-3",
    onChange,
}: ExpertFormTextFieldProps) => {
    return (
        <div className={colClassName}>
            <label className="form-label" htmlFor={id || name}>
                {label}
            </label>
            <input
                type="text"
                className="form-control"
                id={id || name}
                name={name}
                value={value ?? ""}
                onChange={onChange}
            />
        </div>
    );
};